import type {CssValue} from '../../constants'
import {deserializeFunction, serializeFunction} from './function'

const DISABLED_FUNCTION_NAME: string = 'disabled'

export const serializeDisabled = (val: CssValue): CssValue => {
    return serializeFunction({name: DISABLED_FUNCTION_NAME, args: [val]})
}

export const deserializeDisabled = (rule: CssValue): CssValue | undefined => {
    const func = deserializeFunction(rule)
    if (!func) {
        return undefined
    }

    const {name, args} = func
    if (name !== DISABLED_FUNCTION_NAME || args.length !== 1) {
        return undefined
    }

    const [value] = args

    return value
}
